// src/pages/__sandbox.tsx
import * as React from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export default function SandboxPage() {
  const location = useLocation();
  const [sp] = useSearchParams();
  const sessionId = sp.get("sessionId") || "dev";

  return (
    <div style={{ padding: 16, fontFamily: "system-ui" }}>
      <h2 style={{ margin: 0, marginBottom: 8 }}>Sandbox Route OK ✅</h2>
      <div style={{ opacity: 0.8, marginBottom: 8 }}>
        path: <code>{location.pathname}</code>
      </div>
      <div style={{ opacity: 0.8, marginBottom: 12 }}>
        sessionId: <code>{sessionId}</code>
      </div>
      <p style={{ marginTop: 0 }}>
        If you can see this, routing + React mount are working. If this is blank, the route is not being hit or the app
        isn’t mounting for <code>/__sandbox</code>.
      </p>
    </div>
  );
}
